import { useGetReportMedia } from "@entities/reports/lib/hooks/useGeReportMedia";
import { Drawer } from "@shared/ui";
import styles from "./styles.module.scss";
import { BasicInsights } from "./ui/BasicInsights";
import { DataUpdateBanner } from "./ui/DataUpdateBanner";
import { PerformanceHistory } from "./ui/PerformanceHistory";
import { PerformanceOverview } from "./ui/PerformanceOverview";
import { ReportMediaDrawerHeader } from "./ui/ReportMediaDrawerHeader";

interface Props {
  open: boolean;
  onClose: () => void;
  mediaId: string;
  reportId: string;
  reportName: string;
}

export function ReportMediaDrawer({
  open,
  onClose,
  mediaId,
  reportId,
  reportName,
}: Props) {
  const { reportMedia, isFetching, refetch } = useGetReportMedia(
    reportId,
    mediaId,
    open
  );

  const subtitle = reportMedia
    ? `${reportMedia?.username || "Creator"} • ${reportMedia.mediaType || "Media"}`
    : undefined;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      destroyOnClose
      title={
        <ReportMediaDrawerHeader
          title={`${reportName} x Creator Report`}
          subtitle={subtitle}
          onClose={onClose}
        />
      }
      width={600}
      closeIcon={<></>}
      className={styles.drawer}
      styles={{
        body: {
          padding: 0,
        },
        header: {
          padding: 0,
          borderBottom: "none",
        },
      }}
    >
      <div className={styles.drawerContent}>
        <div className={styles.bannersContainer}>
          <DataUpdateBanner
            title="Content metrics are updated daily for 30 days from the post date."
            status={reportMedia?.mediaDataStatus || "Pending"}
            lastUpdatedAt={reportMedia?.mediaDataLastUpdatedAt}
            onRefresh={async () => {
              await refetch();
            }}
            isLoading={isFetching}
          />
          {/* <DataUpdateBanner
            title="Comment data is updated daily for 30 days from the post date."
            status={reportMedia?.commentDataStatus || "Pending"}
            lastUpdatedAt={reportMedia?.commentDataLastUpdatedAt}
            onRefresh={async () => {
              await refetch();
            }}
            isLoading={isFetching}
          /> */}
        </div>
        {reportMedia && (
          <>
            <BasicInsights reportMedia={reportMedia} />
            <PerformanceOverview reportMedia={reportMedia} />
            <PerformanceHistory reportMedia={reportMedia} />
            {/* <RecentComments reportMedia={reportMedia} /> */}
          </>
        )}
      </div>
    </Drawer>
  );
}
